import { fetchCurrentSubscription } from '@/features/subscriptions/subscriptionsSlice'

/**
 * Thunks whose success changes a plan-limited count (users, campuses,
 * dashboards, metrics, this month's data entries).
 */
const LIMITED_MUTATIONS = new Set([
  'campuses/createCampus',
  'campuses/deleteCampus',
  'dashboards/createDashboard',
  'dashboards/cloneDashboard',
  'dashboards/deleteDashboard',
  'metrics/create',
  'metrics/createFromWizard',
  'metrics/createFromTemplate',
  'metrics/delete',
  'metrics/setActive',
  'metrics/clearSampleData',
  'metricEntries/create',
  'metricEntries/delete',
  'users/inviteUser',
  'users/cancelInvitation',
  'users/removeUser',
])

const FULFILLED = '/fulfilled'

/**
 * Refetch plan usage after any change to a limited resource, in one place
 * rather than a `dispatch(fetchCurrentSubscription())` in every handler.
 * Without it the counts were only read on mount, so a page could keep
 * offering an action the server would refuse with a 403 (#213).
 */
export const refreshUsageOnLimitedChange = (store) => (next) => (action) => {
  const result = next(action)
  const type = typeof action?.type === 'string' ? action.type : ''
  if (type.endsWith(FULFILLED) && LIMITED_MUTATIONS.has(type.slice(0, -FULFILLED.length))) {
    store.dispatch(fetchCurrentSubscription())
  }
  return result
}
